module.exports = __webpack_public_path__ + "img/c4.d5d36ba7.png";